const formatIpfsUrl = (input) => input.replace('ipfs://', 'https://ipfs.io/ipfs/')

export default formatIpfsUrl
